import { SET_HEADER_LANGUAGE, SET_PLANT_NAME } from '../types';

const initialState = { language: null, plantName: [] };

export default (state = initialState, action) => {
  let newState = {};

  switch (action.type) {
    case (SET_HEADER_LANGUAGE):
      newState = { language: action.payload };
      break;

    case (SET_PLANT_NAME):
      newState = { plantName: action.payload };
      break;

    default:
      break;
  }

  return {
    ...state,
    ...newState,
  };
};

export const getHeaderLanguage = (state) => state.headerReducer.language;
export const getPlantName = (state) => state.headerReducer.plantName;
